module.exports = __webpack_public_path__ + "static/img/pattern_mini_right_bottom.fbfd4b33.png";